import base32 from "base32.js";

export const base32Encode = (
	payload: string | Uint8Array<ArrayBufferLike>,
): string => {
	const encoder = new base32.Encoder({ type: "rfc4648" });
	return encoder.write(payload).finalize();
};

export const getValueOrFirstEntry = (value: unknown | unknown[]) =>
	Array.isArray(value) && value.length ? value[0] : value;
